import Vue from 'vue';
export default Vue.extend({
    props: {
        chartOptions: {
            type: Object,
            default: {
                data: null,
                scale: null,
                height: 400,
            },
        },
    },
    computed: {
        height: function () {
            return this.chartOptions && this.chartOptions.height
                ? this.chartOptions.height
                : 400;
        },
        data: function () {
            return this.chartOptions && this.chartOptions.data
                ? this.chartOptions.data
                : null;
        },
        scale: function () {
            return this.chartOptions && this.chartOptions.scale
                ? this.chartOptions.scale
                : null;
        },
    },
    data: function () {
        return {
            label: { offset: 12 },
        };
    },
});
